var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 29,
  viewBox: "0 0 24 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.6667 19.8333V12.3333L12 20.6666L0.333353 12.3333V19.8333L12 28.1666L23.6667 19.8333Z",
  fill: "#FDA700"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.6667 8.16663V0.666626L12 8.99996L0.333353 0.666626V8.16663L12 16.5L23.6667 8.16663Z",
  fill: "#FDA700"
})));
export { SvgArrow as ReactComponent };
export default __webpack_public_path__ + "assets/icons/arrow.0d6e9e.svg";